<template>
  <div>
    <w-sliding-popup type="setting" ref="slidingPopup" :title="`[${indexData.dataindexName}] 파싱 패턴 설정`" width="500px" @close="close">
      <div slot="content">
        <el-steps :active="activeStep" finish-status="success">
          <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
        </el-steps>
        <w-parsing-pattern-basic-setting ref="patternBasic" v-show="activeStep === 1" @increaseActiveStep="increaseActiveStep" :pattern-info="patternData" :patternField="patternField" :index-info="indexData"></w-parsing-pattern-basic-setting>
        <w-parsing-pattern-regex-setting ref="patternRegex" v-show="activeStep === 2" @setSelectParsingLog="setSelectParsingLog" :patternField="patternField" :addFlag="addFlag"
        :pattern-info="patternData" :index-info="indexData"></w-parsing-pattern-regex-setting>
      </div>
      <el-row slot="footer" type="flex" justify="space-between">
        <div>
          <el-button size="large" v-show="activeStep === 2" @click="onPrevStep">
            <i class="fal fa-arrow-left mr-r2"></i>
            이전
          </el-button>
        </div>
        <div>
          <el-button size="large" v-show="activeStep === 1" type="solid" @click="onNextStep">다음</el-button>
          <el-button size="large" v-show="activeStep === 2" type="solid" @click="settingPattern">완료</el-button>
          <el-button size="large" @click="onCloseButton">취소</el-button>
        </div>
      </el-row>
    </w-sliding-popup>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import querystring from 'querystring';
import msgUtil from '@/utils/message';
import IndexDataAPI from '@/api/settings/log/lms-dataindex-setting';
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import WParsingPatternBasicSetting from '../components/ParsingPatternBasicSetting';
import WParsingPatternRegexSetting from '../components/ParsingPatternRegexSetting';

export default {
  name: 'WPatternSettingPopup',
  components: {
    WSettingSlidingPopup,
    WParsingPatternBasicSetting,
    WParsingPatternRegexSetting,
  },
  props: {
    selectedIndex: {
      type: Object,
    },
    selectedPattern: {
      type: Object,
    },
    addFlag: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeStep: 1,
      patternField: [],
      parsingLogList: [],
      originPatternField: [],
      stepTitles: ['기본 설정', '패턴 설정'],
      indexData: {
        dataindexName: '',
      },
      patternData: {
        patternName: '',
      },
      title: '패턴 추가',
    };
  },
  watch: {
    selectedPattern: {
      deep: true,
      immediate: true,
      handler(value) {
        if (this.addFlag) {
          this.patternData = {
            dataindexName: '',
            patternName: '',
          };
        } else {
          this.patternData = value;
        }
      },
    },
    addFlag: {
      immediate: true,
      handler() {
        this.title = (this.addFlag) ? '패턴 추가' : '패턴 수정';
        if (this.addFlag) {
          this.patternData = {
            dataindexName: '',
            patternName: '',
          };
        }
      },
    },
  },
  methods: {
    /**
     * 선택한 저장소의 데이터 필드를 조회한다.
     * @author leesy918
     * @return {[type]} [description]
     */
    loadIndexdataField() {
      const params = {
        dataindexId: this.indexData.dataindexId,
        patternId: this.selectedPattern.patternId,
      };
      if (this.addFlag) {
        IndexDataAPI.getDataindexField(params).then((response) => {
          if (response.data.success) {
            const resultMap = response.data.data;
            this.patternField = resultMap.indexFieldList;
            this.originPatternField = cloneDeep(this.patternField);
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 목록', false));
          throw new Error(e);
        });
      } else {
        IndexDataAPI.getDataindexPatternField(params).then((response) => {
          if (response.data.success) {
            this.patternField = response.data.data;
            this.originPatternField = cloneDeep(this.patternField);
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 목록', false));
          throw new Error(e);
        });
      }
    },
    /**
     * 파싱 필드 순서 변경 시 데이터 설정
     * @author leesy918
     * @param  {[type]} data [description]
     */
    setSelectParsingLog(data) {
      this.parsingLogList = data;
    },
    /**
     * 쿼리 스트링 작성 함수
     * @author leesy918
     */
    setQueryString() {
      const queryString = {
        dataindexId: this.selectedIndex.dataindexId,
        patternId: this.patternData.patternId,
        patternName: this.patternData.patternName,
        patternDesc: this.patternData.patternDesc,
        patternRegex: this.patternData.patternRegex,
        ignoreRegexFlag: this.patternData.ignoreRegexFlag,
        patternTimestamp: this.patternData.patternTimestamp,
      };
      return queryString;
    },
    /**
     * 플래그에 따른 패턴 저장/수정 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    settingPattern() {
      if (this.addFlag) {
        // 추가 영역
        const payload = this.parsingLogList;
        const queryString = this.setQueryString();

        IndexDataAPI.addParsingPattern(querystring.stringify(queryString), payload).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '파싱패턴', true));
            this.$emit('loadData');
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '파싱패턴', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '파싱패턴', false));
          throw new Error(e);
        });
      } else {
        // 수정 영역
        const params = {
          originPattern: this.selectedPattern,
          updatePattern: this.patternData,
          patternFieldList: this.parsingLogList,
        };

        IndexDataAPI.updateParsingPattern(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '파싱패턴', true));
            this.$emit('loadPatternData', this.selectedIndex);
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '파싱패턴', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '파싱패턴', false));
          throw new Error(e);
        });
      }
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.indexData = cloneDeep(this.selectedIndex);
      this.$nextTick(() => {
        if (!this.addFlag) {
          this.patternData = cloneDeep(this.selectedPattern);
        }
        if (this.addFlag) {
          this.patternData.ignoreRegexFlag = 'Y';
        }
        this.patternData.dataindexId = this.indexData.dataindexId;
        this.loadIndexdataField();
      });
    },
    increaseActiveStep() {
      this.$refs.patternRegex.setMappingField();
      this.activeStep = 2;
    },
    onNextStep() {
      this.$refs.patternBasic.nextStep();
    },
    onPrevStep() {
      this.activeStep = 1;
    },
    onCloseButton() {
      this.close();
    },
    close() {
      // 팝업 비활성화 시 데이터 초기화 작업 필요
      this.patternField = [];
      this.$refs.patternBasic.resetField();
      this.activeStep = 1;
      this.indexData = {
        dataindexName: '',
      };
      this.patternData = {
        patternName: '',
      };
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/popup/PatternSettingPopup.vue